import {
  FETCH_ALL_PRODUCT_RECOMMENDATIONS,
} from './../../mutation-types';

export default {
  [FETCH_ALL_PRODUCT_RECOMMENDATIONS](state, productRecommendation) {
    state.all = productRecommendation;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productRecommendation/mutations.js